/** Mga ulat bawat agent at mga label ng KPI (M29). Shell created by WP-M29-SCHEMA1: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const agentReports = {
  tickets: {
    title: "Ulat bawat agent",
    sub: "Mga ticket bawat agent, {{period}}. Hindi binibilang ang mga ticket na walang hawak.",
    caption: "Mga numero ng ticket bawat agent",
    teamFilter: "Team",
    allTeams: "Lahat ng team",
    export: "I-export bilang CSV",
    exportDone: "Na-save ang {{file}}.",
    exportFailed: "Hindi namin ma-export ang ulat bawat agent. Pakisubukan muli.",
    total: "Lahat ng agent",
    seconds: "{{value}} s",
    openLink: "Buksan ang ulat bawat agent",
    columns: {
      agent: "Agent",
      volume: "Mga ticket",
      resolved: "Nalutas",
      firstResponse: "Unang tugon",
      resolution: "Paglutas",
      slaMet: "Natupad na SLA",
      csat: "CSAT",
      reopens: "Muling binuksan",
    },
    empty: {
      title: "Walang numero ng agent sa panahong ito",
      body: "Lalabas dito ang mga numero kapag may mga ticket na nakatalaga sa mga tao. Magtalaga ng mga ticket sa inyong team, o pumili ng mas mahabang panahon.",
      action: "Buksan ang mga ticket",
      teamTitle: "Walang numero ang sinuman sa team na ito sa panahong ito",
      teamBody: "Walang ticket na naitalaga sa sinuman sa napiling team sa panahong ito. Pumili ng ibang team o ipakita ang lahat.",
      teamAction: "Ipakita ang lahat ng team",
    },
  },
  chats: {
    title: "Ulat ng mga chat",
    sub: "Mga live chat bawat agent, {{period}}. Binibilang ang bawat numero sa araw na nangyari ito.",
    caption: "Mga numero ng chat bawat agent",
    viewLabel: "Mga hilera",
    views: { member: "Bawat agent", day: "Bawat araw" },
    teamFilter: "Team",
    allTeams: "Lahat ng team",
    export: "I-export ang CSV",
    exportDone: "Na-save ang {{file}}.",
    exportFailed: "Hindi namin ma-export ang ulat ng chat. Pakisubukan muli.",
    total: "Lahat ng agent",
    asOf: "Mga numero hanggang {{time}}. Ina-update kada 15 minuto.",
    error: "Hindi namin ma-load ang ulat ng chat.",
    concurrencyValue: "{{avg}} (pinakamarami {{peak}})",
    columns: {
      agent: "Agent",
      day: "Araw",
      chats: "Mga chat",
      firstResponse: "Unang tugon ng staff",
      handleTime: "Oras ng pag-asikaso",
      concurrency: "Sabay na chat",
      transfers: "Mga inilipat",
      fcr: "Naresolba sa unang kontak",
      csat: "CSAT",
      aiAssisted: "Mga sagot na may tulong ng AI",
    },
    definitionsTitle: "Paano binibilang ang mga numerong ito",
    definitions: {
      chats: "Mga chat na tinanggap at sinagot ng isang tao: kinuha, tinanggap mula sa alok, itinalaga sa kanila, o sinalihan sa pamamagitan ng pagsagot, na may kahit isang sagot mula sa kanila. Binibilang sa araw ng pagtanggap, minsan lang bawat tao at chat.",
      firstResponse: "Karaniwang oras mula nang itinalaga o tinanggap ng tao ang chat hanggang sa una nilang sagot dito. Ang chat na sinalihan sa pamamagitan ng unang pagsagot ay walang oras ng paghihintay at hindi isinasama.",
      handleTime: "Karaniwang oras mula sa pagtanggap hanggang sa pagsasara, para sa mga nasagot na chat na hawak ng tao nang ito ay naresolba o isinara. Binibilang sa araw ng pagsasara.",
      concurrency: "Karaniwang bilang ng chat na hawak ng tao nang sabay habang may hawak na kahit isa, at ang pinakamarami sa iisang sandali. Hawak ang chat mula sa pagtanggap hanggang maisara, mailipat, o tumahimik nang 30 minuto.",
      transfers: "Mga nasagot na chat na inilipat ng tao: itinalaga sa iba o ibinalik sa pila.",
      fcr: "Bahagi ng mga nasagot na chat ng tao, na sila ang nagsara, na walang muling pagbubukas at walang bagong chat mula sa parehong customer sa parehong paksa sa loob ng 72 oras. Binibilang ang chat kapag lumipas na ang 72 oras.",
      csat: "Karaniwang rating (1 hanggang 5) na ibinigay ng mga customer sa mga chat na huling hinawakan ng tao. Binibilang sa araw ng rating.",
      aiAssisted: "Bahagi ng mga sagot ng tao na sumunod sa AI draft na hiniling nila sa parehong chat mula sa huli nilang sagot.",
    },
    empty: {
      title: "Walang numero ng chat sa panahong ito",
      body: "Lalabas dito ang mga numero kapag may tumanggap at sumagot ng live chat. Ina-update ang ulat kada 15 minuto, kaya maaaring hindi pa lumabas ang kakasagot lang na chat.",
      action: "Buksan ang inbox",
      teamTitle: "Walang numero ng chat ang sinuman sa team na ito sa panahong ito",
      teamBody: "Walang sumagot ng chat mula sa napiling team sa panahong ito. Pumili ng ibang team o ipakita ang lahat.",
      teamAction: "Ipakita ang lahat ng team",
    },
  },
  kpi: {
    aiAnswerTime: "Oras ng sagot ng AI",
    staffFirstResponse: "Unang tugon ng staff",
    aiAnswerNote: "Gaano kabilis sumagot ang assistant",
    staffNote: "Mula sa pagpasa hanggang sa unang mensahe ng staff",
    staffNone: "Wala pang naitugon ng staff na pagpasa",
    p95: "p95 {{value}}",
    ms: "{{value}} ms",
    seconds: "{{value}} s",
    minutes: "{{value}} min",
    hours: "{{value}} h",
  },
  definitions: {
    aiAnswerTime: "Gaano katagal sumagot ang assistant sa isang mensahe. Wala itong sinasabi tungkol sa bilis ng pagsagot ng mga tao.",
    staffFirstResponse: "Oras mula nang ipasa ang usapan sa staff hanggang sa unang mensaheng ipinadala ng isang tao. Hindi binibilang ang mga pagpasang wala pang sumasagot.",
  },
  schedules: {
    open: "Mga naka-iskedyul na export",
    title: "Mga naka-iskedyul na export",
    sub: "Mag-e-mail ng link sa CSV bawat agent araw-araw o lingguhan. Gumagana ang link sa loob ng 3 araw; hindi kailanman ina-attach ang file.",
    error: "Hindi namin ma-load ang mga naka-iskedyul mong export.",
    reports: { agent_tickets: "Agent report (mga ticket)", agent_chats: "Chat report (mga live chat)" },
    cadence: { daily: "Araw-araw", weekly: "Lingguhan" },
    empty: {
      title: "Wala pang naka-iskedyul na export",
      body: "Pumili ng report, oras, at kung sino ang tatanggap. Makakatanggap sila ng link sa e-mail na hihinto sa paggana pagkalipas ng 3 araw.",
      unavailable: "Walang magagamit na per-agent report sa workspace na ito, kaya walang maiiskedyul.",
      action: "Bagong iskedyul",
    },
    list: {
      label: "Mga naka-iskedyul na export",
      daily: "Araw-araw ng {{time}} ({{zone}})",
      weekly: "Tuwing {{day}} ng {{time}} ({{zone}})",
      recipients: "Mga tatanggap ({{count}}): {{list}}",
      next: "Susunod na e-mail: {{time}}",
      noNext: "Naka-pause: walang ipapadalang e-mail",
      last: "huling naipadala {{time}}",
      count: "{{count}} sa {{max}} na iskedyul",
      withReferences: "May customer reference",
      pausedBadge: "Naka-pause",
      enabledLabel: "Ipadala ang {{name}}",
      edit: "I-edit ang {{name}}",
      editShort: "I-edit",
      delete: "I-delete ang {{name}}",
      paused: "Na-pause ang {{name}}.",
      resumed: "Ipapadala muli ang {{name}}.",
    },
    form: {
      newTitle: "Bagong iskedyul",
      editTitle: "I-edit ang iskedyul",
      name: "Pangalan",
      namePlaceholder: "Agent report tuwing Lunes",
      nameRequired: "Bigyan ng pangalan ang iskedyul.",
      report: "Report",
      reportLocked: "Hindi mapapalitan ang report. Gumawa ng bagong iskedyul para sa ibang report.",
      cadence: "Gaano kadalas",
      weekday: "Araw ng linggo",
      hour: "Oras",
      timezone: "Time zone",
      recipients: "Mga tatanggap",
      recipientsHint: "Mga e-mail address na pinaghiwalay ng kuwit o bagong linya, hanggang {{count}}.",
      recipientsPlaceholder: "pangalan@example.com",
      recipients_empty: "Magdagdag ng kahit isang e-mail address.",
      recipients_invalid: "May address na hindi wastong e-mail address.",
      recipients_tooMany: "Hanggang {{count}} ang tatanggap ng isang iskedyul.",
      references: "Isama ang customer reference",
      referencesHint: "Nagdadagdag ng column ng mga reference ng customer na sinagot ng bawat agent. Mababasa ito ng sinumang may link hanggang mag-expire ito.",
      referencesLocked: "Ang mga may karapatang tumingin ng customer reference lang ang makakapag-on nito.",
      create: "Gumawa ng iskedyul",
      save: "I-save ang mga pagbabago",
      created: "Nagawa ang iskedyul.",
      saved: "Na-save ang iskedyul.",
    },
    remove: {
      title: "I-delete ang iskedyul na ito?",
      body: "Titigil na ang {{name}}, at hihinto rin sa paggana ang mga link na naipadala na nito.",
      confirm: "I-delete ang iskedyul",
      done: "Na-delete ang iskedyul.",
    },
  },
};
